import React from 'react'
import { Button, Icon, Message } from 'semantic-ui-react'
import { isObject, navigate } from '../helpers'
import { useNavigate } from 'react-router-dom'

export default function Messages({ messages, attached, onDismiss }) {
	const routerNavigateFn = useNavigate()

	if (typeof messages !== 'object' || !Array.isArray(messages)) return null

	return messages.map((message, i) => {
		let messageAttachType = null
		if (attached === 'top' && i === 0) {
			messageAttachType = 'top'
		} else if (attached === 'bottom' && i === messages.length - 1) {
			messageAttachType = 'bottom'
		} else if (attached) {
			messageAttachType = true
		}

		let messageIcon = null
		if (typeof message.icon === 'string' && message.icon.length > 0) {
			messageIcon = <Icon name={message.icon} />
		}

		let messageContent = null
		if (typeof message.content === 'string' || (message.content !== null && typeof message.content === 'object' && React.isValidElement(message.content))) {
			if (message.html) {
				messageContent = <div dangerouslySetInnerHTML={{__html: message.content}}></div>
			} else {
				messageContent = message.content
			}
		}

		let messageHeader = null
		if (typeof message.title === 'string' || (message.title !== null && typeof message.title === 'object' && React.isValidElement(message.title))) {
			messageHeader = <Message.Header>{message.title}</Message.Header>
		}

		let messageActionButton = null
		if (isObject(message.action) && typeof message.action.link === 'string' && typeof message.action.name === 'string') {
			messageActionButton = <p>
				<Button
					as="a"
					color={message.action.color}
					href={message.action.link}
					onClick={e => {
						if (!e.defaultPrevented) e.preventDefault()
						const { ctrlKey, shiftKey } = e
						const target = (ctrlKey || shiftKey) ? '_blank' : '_self'
						navigate(message.action.link, target, {}, routerNavigateFn)
					}}
				>
					{message.action.name}
					{typeof message.action.icon === 'string' && message.action.icon.length > 0 ? <Icon name={message.action.icon} /> : null}
				</Button>
			</p>
		}

		return <Message
			key={message.key}
			onDismiss={message.dismissable && typeof onDismiss === 'function' ? () => onDismiss(message.key) : null}
			attached={messageAttachType}
			color={message.color}
			className={((message.className ?? '') + (!message.title ? ' small-icon' : '')).trim()}
			compact={message.compact}
			size={message.size}
			error={message.type === 'error'}
			warning={message.type === 'warning'}
			success={message.type === 'success'}
			info={message.type === 'info'}
			visible={message.visible}
			icon={messageIcon !== null}
			header={message.title}
			content={message.html ? <div dangerouslySetInnerHTML={{__html: message.content}}></div> : message.content}
		>
			{messageIcon}
			<Message.Content>
				{messageHeader}
				{messageActionButton ? <p>{messageContent}</p> : messageContent}
				{messageActionButton}
			</Message.Content>
		</Message>
	})
}